export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/store/modals-portals/modal-allproperty.store.ts"